import { Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { SafeResourceUrl } from "@angular/platform-browser";
import { ConsoleLogHandlerService } from "@app-cfs/shared/services";
import { IframeMessageData, IframeMessageTypes } from "clearline-common";

@Component({
  selector: "app-iframe",
  templateUrl: "./iframe.component.html",
  styleUrls: ["./iframe.component.scss"]
})
export class IframeComponent implements OnDestroy {
  @Input() iframeUrl!: SafeResourceUrl;

  @Output() onLoad = new EventEmitter();
  @Output() onClose = new EventEmitter();
  @Output() onUserActivity = new EventEmitter();

  iframeWindow: Window | null = null;

  private messageEventHandler: (event: MessageEvent) => void;

  constructor(private consoleLogHandler: ConsoleLogHandlerService) {
    this.messageEventHandler = this.iframePostMessageReceiver.bind(this);
  }

  onLoadHandler(iframe: HTMLIFrameElement) {
    if (!iframe.src) return; // Skip initial hit.
    this.consoleLogHandler.log("~iFrame Load", {
      src: iframe.src,
      iframe,
      contentDocument: iframe.contentDocument,
      window: iframe.contentWindow
    });
    this.iframeWindow = iframe.contentWindow;

    window.addEventListener("message", this.messageEventHandler, false);
    this.postIframeMessage(IframeMessageTypes.init, { projectName: "cfs" });
    this.onLoad.emit();
  }

  ngOnDestroy(): void {
    window.removeEventListener("message", this.messageEventHandler);
  }

  private iframePostMessageReceiver(event: MessageEvent) {
    const eventData: IframeMessageData<any> = event.data;

    switch (eventData.type) {
      case IframeMessageTypes.formSubmitted:
        this.onClose.emit();
        break;
      case IframeMessageTypes.userActivity:
        this.onUserActivity.emit();
        break;
      case IframeMessageTypes.scanCompleted:
      case IframeMessageTypes.scanCancelled:
        const { data, type } = eventData;

        this.postIframeMessage(type, data);
        break;

      default:
        break;
    }
  }

  private postIframeMessage(type: IframeMessageTypes, data: {}) {
    if (this.iframeWindow) {
      const messageData: IframeMessageData<any> = { type, data };
      this.iframeWindow.postMessage(messageData, "*");
    }
  }
}
